<nav class="navbar navbar-light bg-light border-bottom fixed-top">
  <a class="navbar-brand" routerLink="/"><img src="/assets/copas-logo.png"></a>
  <div class="navbar-expand mr-auto">
    <div class="navbar-nav">
      <a class="nav-item nav-link mr-2" routerLink="/gitlab/dashboard" routerLinkActive="active"><i
        class="fab fa-gitlab mr-2"></i>Gitlab Dashboard</a>

      <a class="nav-item nav-link mr-2" routerLink="/build-configs" routerLinkActive="active"><i
        class="far fa-brackets-curly mr-2"></i>Build Config</a>
    </div>
  </div>
  <div class="navbar-expand ml-auto navbar-nav">
    <div class="navbar-nav">
      <a class="nav-item nav-link" (click)="accountManagement()" data-toggle="tooltip" [title]="username">
        <i class="fas fa-user"></i>
      </a>
      <a class="nav-item nav-link" (click)="logout()" data-toggle="tooltip" title="logout">
        <i class="fas fa-sign-out"></i>
      </a>
    </div>
  </div>
</nav>
